module.exports = {
  setSubscription: (state, array) => {
    state.subscription = array
  },
  setSubscriptions: (state, array) => {
    state.subscriptions = array
  },
  setAvailableSubscriptions: (state, array) => {
    state.availableSubscriptions = array
  },
}